export const AGENT_ROLE_ID = "2";
export const EMPLOYER_ADMIN_ROLE_ID = "1";
export const AGENT_LINK_ROLE_TYPES = {
  ADMIN: "ADMIN",
  AGENT: "AGENT",
};
